<div id="chart-container">
  <div [id]="id" class="chart-viewport" inViewport (inViewportAction)="loadChart($event)"></div>
  <sesio-loader *ngIf="loadingData"></sesio-loader>
</div>
